<template>
    <v-app id="app" class="application">
        <div>
        <div class="text-center" id="logoContent">
        <router-link to="/task-dashboard" v-if="defaultApplicationId==2">
         <img style="padding: 1.5rem 0; width:80px; mix-blend-mode:darken"
             :src="'/assets/images/logos/' + client_logo_name" :alt="constants.client_version_Id" />
         </router-link>
         <router-link to="/" v-else>
         <img class="cts-logo" style="padding: 1.5rem 0; width:80px; mix-blend-mode:darken"
             :src="'/assets/images/logos/' + client_logo_name" :alt="constants.client_version_Id" />
         </router-link>
        </div>
        <aside class="sidebar" :class="{ show: isShow }">
            <div class="aside-content">
                <div class="close-menu py-2 text-end" @click="isShow = false">
                    <i class="fa fa-close"></i>
                </div>
                <!-- <div class="text-center">
                    <router-link to="/inbox">
                        <img class="w-100" :src="'/assets/images/logos/' + client_logo_name" :alt="constants.client_version_Id" />
                    </router-link>
                </div> -->
                <nav>
                    <v-btn class="user-btn p-0" v-on:click="openProfileBox" v-if="constants.client_version_Id != 'DGS'">
                        <v-avatar class="sidebar-image m-0 " color="#eff2f5" size="43" v-tooltip="$t(this.tooltipDisplayName)">
                            <span v-if="this.userAbbreviationSrc === ''">{{ this.userAbbreviation }}</span>
                        </v-avatar>
                        <div id="userName" style="display:none">{{this.tooltipDisplayName}}</div>
                    </v-btn>

                    <ul class="nav flex-column mt-4 flex-nowrap" style="max-height: calc(70vh - 60px); overflow-y: auto;" v-if="constants.userActions.menu">
                        <div v-for="(item,i) in constants.userActions.menu.filter(x=>x.icon != null && x.icon != '' && !showInProfileMenus.includes(x.menuItems.to.toLowerCase()))" :key="i">
                            <!-- class,icon,labelText -->
                            <router-link v-if="['/inbox', '/draft', '/sent', '/followup', '/archive'].includes(item.menuItems.to.toLowerCase())" active-class="active" :to="item.menuItems.to" :class="item.menuItems.class">
                                <div class="activeTab">
                                <v-icon> {{ item.icon }} </v-icon>
                                <label class="mb-2"> {{ $t(item.menuItems.labelText) }} </label>
                                <template v-if="item.menuItems.to.toLowerCase() == '/inbox'">
                                    <v-badge color="red" style="position: absolute; z-index: 90000; padding-top: 7px;" :content='inboxCount' v-if="inboxCount !== 0" inline></v-badge>
                                </template>
                                <template v-if="item.menuItems.to.toLowerCase() == '/cced'">
                                    <v-badge color="red" style="position: absolute; z-index: 90000; padding-top: 7px;" :content='ccedCount' v-if="ccedCount !== 0" inline></v-badge>
                                </template>
                                <template v-if="item.menuItems.to.toLowerCase() == '/draft'">
                                    <v-badge color="red" style="position: absolute; z-index: 90000; padding-top: 7px;" :content='draftCount' v-if="draftCount !== 0" inline></v-badge>
                                </template>
                                <template v-if="item.menuItems.to.toLowerCase() == '/sent'">
                                    <v-badge color="red" style="position: absolute; z-index: 90000; padding-top: 7px;" :content='sentCount' v-if="sentCount !== 0" inline></v-badge>
                                </template>
                                <template v-if="item.menuItems.to.toLowerCase() == '/completed'">
                                    <v-badge color="red" style="position:absolute;z-index:90000; padding-top: 7px;" :content='completedCount' v-if="completedCount !== 0" inline></v-badge>
                                </template>
                                <template v-if="item.menuItems.to.toLowerCase() == '/followup'">
                                    <v-badge color="red" style="position: absolute; z-index: 90000; padding-top: 7px;" :content='followUpCount' v-if="followUpCount !== 0" inline></v-badge>
                                </template>
                                <template v-if="item.menuItems.to.toLowerCase() == '/archive'">
                                    <v-badge color="red" style="position: absolute; z-index: 90000; padding-top: 7px;" :content='archiveCount' v-if="archiveCount !== 0" inline></v-badge>
                                </template>
                                </div>
                            </router-link>
                            <router-link v-else active-class="active" :to="item.menuItems.to" :class="item.menuItems.class">
                                <!-- v-else-if="!['/reports', '/dashboard', '/delegation', '/admin'].includes(item.menuItems.to.toLowerCase())" -->
                                <div class="activeTab">
                                <v-icon> {{ item.icon }} </v-icon>
                                <label class="mb-2">{{ $t(item.menuItems.labelText) }}</label>   </div>
                            </router-link>
                        </div>
                        <div v-if="showAppSwitchButton">
                            <v-menu offset-y content-class="mt-0">
                                <template v-slot:activator="{ on, attrs }">
                                    <div v-bind="attrs" v-on="on">
                                        <v-icon color="#024976">mdi-bell-outline</v-icon>
                                        <label class="mb-2">Switch</label>
                                    </div>
                                </template>
                                <v-list>
                                    <v-list-item @click="setDefaultApplication(1)" v-if="this.defaultApplicationId != 1 && availableApplications.includes(1)">
                                        <v-list-item-title>CTS</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="setDefaultApplication(2)" v-if="this.defaultApplicationId != 2 && availableApplications.includes(2)">
                                        <v-list-item-title>TMS</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="setDefaultApplication(3)" v-if="this.defaultApplicationId != 3 && availableApplications.includes(3)">
                                        <v-list-item-title>MMS</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </ul>
                </nav>
            </div>
        </aside>
        </div>
        <section class="main-content-wrapper">
            <!--header-->
            <header class="topnavbar-wrapper lg-header">
                <div class="nav-wrapper align-items-center">
                    <v-btn color="white" class="p-0 toggle-menu" @click="isShow = true">
                        <i class="fa fa-bars text-gray"></i>
                    </v-btn>
                    <div v-if="constants.client_version_Id != 'DDA'">
                        <h1 class="page-title" v-if="this.defaultApplicationId == 1 && constants.client_version_Id !='ADFD' && constants.client_version_Id !='ADHA'">{{ $t("res_ApplicationTitle") }}</h1>
                        <h1 class="page-title" v-if="this.defaultApplicationId == 1 && constants.client_version_Id == 'ADFD'">{{ $t("res_ADFDTitle") }}</h1>
                        <h1 class="page-title" v-if="this.defaultApplicationId == 1 && constants.client_version_Id == 'ADHA'">{{ $t("res_ADHATitle") }}</h1>                        
                        <h1 class="page-title" v-if="this.defaultApplicationId == 2">Task Management</h1>
                        <h1 class="page-title" v-if="this.defaultApplicationId == 3">Meeting Management</h1>
                    </div>
                    <div v-else>
                        <img src="/assets/images/logos/dda_banner.png" style="width: 25%" :alt="constants.client_version_Id" />
                    </div>
                </div>
                <div class="nav-wrapper">
                    <div v-if="this.defaultApplicationId == 1">
                        <div class="d-flex header-search" v-if="hideElasticSearch">
                            <v-text-field class="search-field" v-model="searchQuery" solo :label="$t('res_Label_SearchPlaceHolder')"
                                    prepend-icon="mdi-magnify" @click:prepend="applyFilters({},true)" @keydown.enter="applyFilters({},true)">
                            </v-text-field>
                            <v-btn v-if="searchQuery.length" color="white" class="p-0 close-btn" bottom v-on:click="clearSearchResult">
                                <img src="/assets/images/icons/close.svg" alt="search" />
                            </v-btn>
                            <button class="expand-advance-search" @click="showAdvancedSearchDialog = !showAdvancedSearchDialog" v-if="!hideOpenAdvancedSearchFiltersFromHomePage">
                                <v-icon :style="isLanguageEn ? 'margin-right: 16px;' : 'margin-left: 16px;'">mdi-chevron-down</v-icon>
                            </button>
                        </div>
                        <div v-else>
                            <div class="search-box position-relative" v-if="expandSearch">
                                <div class="d-flex header-search">
                                    <v-select :items="search_modes" label="Solo field" v-model="search_mode"
                                            :menu-props="{ bottom: true, offsetY: true }" solo></v-select>
                                    <v-text-field class="search-field" v-model="searchQuery" solo :label="$t('res_Label_SearchPlaceHolder')"
                                            prepend-icon="mdi-magnify" @click:prepend="searchButtonClicked" @keydown.enter="searchButtonClicked">
                                    </v-text-field>
                                    <v-btn color="white" class="p-0 close-btn"
                                        v-on:click="clearSearchResult">
                                        <img src="/assets/images/icons/close.svg" alt="search" />
                                    </v-btn>
                                </div>
                            </div>
                            <v-btn v-if="!expandSearch" color="white" class="p-0" v-on:click="expandSearch = true">
                                <img src="/assets/images/icons/search.svg" alt="search" />
                            </v-btn>
                        </div>
                    </div>

                    <!--System Notifications button-->
                    <v-btn id="red-notif-btn" style="padding:0; width:40px;" class="dgs-new-button-inner p-0" v-on:click="OpenSystemNotificationsDialog"
                           :class="[{ 'red-noti' : this.systemNotificationList.length > 0 }]">
                        <v-icon color="#024976">mdi-bell-outline</v-icon>
                    </v-btn>

                    <!-- lang switch btn -->

                    <div style="text-align: center;">
                        <v-btn style="padding:0; width:40px;" @click="changeRTL(true)" v-if="isLanguageEn" class="dgs-new-button-inner">
                            <v-icon color="#024976" > mdi-abjad-arabic </v-icon>

                        </v-btn>
                        <v-btn style="padding:0; width:40px;" @click="changeRTL(false)" v-if="!isLanguageEn" class="dgs-new-button-inner">
                            <v-icon color="#024976"> mdi-abugida-devanagari </v-icon>
                        </v-btn>
                    </div>

                      <div style="text-align: center;" v-if="showHelpAppVal == true">
                        <v-btn style="padding:0; width:40px;" @click="openHelpUrl()" class="dgs-new-button-inner">
                            <v-icon>mdi-help-circle-outline</v-icon>
                        </v-btn>
                    </div>

                    <v-btn class="user-btn p-0" v-on:click="openProfileBox" v-if="constants.client_version_Id == 'DGS'">
                        <v-avatar class="sidebar-image m-0 " color="#eff2f5" size="43">
                            <span v-if="this.userAbbreviationSrc === ''" style="font-size:1.3rem">{{ this.userAbbreviation }}</span>
                        </v-avatar>
                    </v-btn>

                    <v-menu offset-y content-class="mt-0" 
                        v-if="hasPermission('CreateOutgoingByFile') 
                                || hasPermission('CreateOutgoing') 
                                || ( isCircularEnabled && hasPermission('CreateCircular') ) 
                                || ( isDecreeEnabled && hasPermission('CreateDecree') )">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="menu-toggle-btn btn-add" color="primary" v-bind="attrs" v-on="on" style="width: 130px">
                                <span>{{ $t("res_MenuItems_CreateNew") }}</span>
                                <v-icon>mdi-chevron-down</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item v-if="hasPermission('CreateIncoming')" @click="openCreateIncomingPopup">
                                <v-list-item-title>{{ $t("res_MenuItems_CreateIncoming") }}</v-list-item-title>
                            </v-list-item>
                            <v-menu content-class="align-bottom-left1" :left="isLanguageEn" :right="!isLanguageEn" top offset-x offset-y
                                v-if="hasPermission('CreateOutgoingByFile') || hasPermission('CreateOutgoing')">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-list-item v-bind="attrs" v-on="on" class="justify-content-between">
                                        {{ $t("res_MenuItems_Outgoing") }}
                                        <v-icon>mdi-chevron-down</v-icon>
                                    </v-list-item>
                                </template>
                                <v-list>
                                    <v-list-item v-if="hasPermission('CreateOutgoingByFile')" @click="openCreateOutgoingAttachPopup">{{ $t("res_MenuItems_ByFile") }}</v-list-item>
                                    <v-list-item v-if="hasPermission('CreateOutgoing')" @click="openCreateOutgoingPopup('')">{{ $t("res_MenuItems_ByTemplate") }}</v-list-item>
                                </v-list>
                            </v-menu>
                            <v-list-item v-if="isCircularEnabled && hasPermission('CreateCircular')" @click="openCreateOutgoingPopup('5')">
                                <v-list-item-title>{{ $t("res_MenuItems_Circular") }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="isDecreeEnabled && hasPermission('CreateDecree')" @click="openCreateOutgoingPopup('4')">
                                <v-list-item-title>{{ $t("res_MenuItems_Decree") }}</v-list-item-title>
                            </v-list-item>
                             <v-list-item v-if="isMOMEnabled && hasPermission('CreateMOM')" @click="openCreateOutgoingPopup('6')">
                                <v-list-item-title>{{ $t("res_MenuItems_MOM") }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </header>

            <router-view />
        </section>

        <v-dialog v-model="profileDialog" content-class="profile-dialog m-0" width="380px" >
            <v-card style="padding-bottom: 0px">
                <v-card-title class="p-0" style="margin-bottom: 1.75rem; line-height: 1.5rem">
                    {{ $t("res_DialogHeaders_Profile") }}
                </v-card-title>
                <v-card-text>
                    <div  v-if="availableApplications.includes(1)">
                        <v-label>{{ $t("res_Msgs_SelectDefualtStructure") }}</v-label>
                        <div v-if="all_user_structures">
                            <multi-select class="light-bg" v-model="user_structure" label="structureName" track-by="structureId"
                                          open-direction="bottom" :options="all_user_structures" :searchable="true"
                                          :loading="loading" :internal-search="false" :clear-on-select="false"
                                          :close-on-select="true" :options-limit="300" :max-height="600"
                                          :show-no-results="false" :hide-selected="false" :multiple="false"
                                          @input="userStructureChanged" :placeholder="$t('res_Label_SelectOption')">
                                <template slot="noOptions" slot-scope="props">
                                    {{ $t("res_Msgs_EmptySearch") }}
                                </template>
                            </multi-select>
                        </div>
                    </div>
                    <div class="mt-3">
                        <label>{{ $t("res_DisplayNameTitle") }}: &nbsp;</label>
                        <label style="font-weight: 500">{{ this.userDisplayName }}</label>
                    </div>
                    <div class="mt-3">
                        <label>{{ $t("res_MenuItems_Email") }}: &nbsp;</label>
                        <label style="font-weight: 500">{{ this.userEmail }}</label>
                    </div>
                    <div class="mt-3" style="display: none">
                        <div>
                            <a @click="openAddTransferFavorite" style="text-decoration: underline; color: #5757e0;">
                                {{ $t("res_MenuItems_ManageTransferFavorites") }}
                            </a>
                        </div>
                    </div>
                </v-card-text>
                <div v-if="availableApplications.includes(1)">
                    <v-divider></v-divider>
                <nav>
                    <div class="row d-flex justify-content-center" v-if="constants.userActions.menu">
                        <div v-if="hasPermission('ManageSignatures')" class="col-3 profile-icons-container profileIconsCustom" @click="manageUserSignaturesDialog = true">
                            <a><v-icon>mdi-manage-signature</v-icon></a>
                            <label>{{ $t("res_Lable_ManageSignatures") }}</label>
                        </div>
                        <div class="col-3 profile-icons-container profileIconsCustom" @click="openChangePinCode">
                            <a><v-icon>mdi-pin-code</v-icon></a>
                            <label>{{ $t("res_MenuItems_ChangePinCode") }}</label>
                        </div>
                        <div class="col-3 profile-icons-container" v-for="(item,i) in constants.userActions.menu.filter(x=>x.icon != null && x.icon != '' &&  showInProfileMenus.includes(x.menuItems.to.toLowerCase()))" :key="i">
                            <!-- class,icon,labelText -->
                            <router-link class="profile-icons profileIconsCustom" @click.native="profileDialog=false" active-class="active" :to="item.menuItems.to" :class="item.menuItems.class">
                                <!-- v-else-if="!['/reports', '/dashboard', '/delegation', '/admin'].includes(item.menuItems.to.toLowerCase())" -->
                               <div class="activeTab">
                                <v-icon> {{ item.icon }} </v-icon>
                                <label>{{ $t(item.menuItems.labelText) }}</label> </div>
                            </router-link>
                        </div>
                    </div>
                </nav>
                </div>
              
                <v-divider></v-divider>
                <v-card-actions class="p-0">
                    <v-spacer></v-spacer>
                    <v-btn class="mb-3 line-height-20" color="primary" width="100px" @click="logout()">
                        {{ $t("res_MenuItems_Logout") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="changePinCodeDialog" content-class="small-dialog" width="350" height="650" persistent>
            <v-card>
                <v-card-title>
                    {{ $t("res_DialogTitle_ChangePinCode") }}
                </v-card-title>
                <div class="card-body">
                    <v-row class="mt-2">
                        <v-col class="col-md-12">
                            <span class="mb-2">{{ $t("res_Label_SetNewPinCode") }} <span style="color: red">*</span></span>
                            <v-text-field label="" solo :type="pincode.showNew ? 'text' : 'password'"
                                          v-model="pincode.setNewPin" :append-icon="pincode.showNew ? 'mdi-eye' : 'mdi-eye-off'"
                                          @click:append="pincode.showNew = !pincode.showNew"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col class="col-md-12">
                            <span class="mb-2">{{ $t("res_Label_ConfirmNewPinCode") }} <span style="color: red">*</span></span>
                            <v-text-field label="" solo :type="pincode.showConfirm ? 'text' : 'password'"
                                          v-model="pincode.confirmNewPin" :append-icon="pincode.showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                                          @click:append="pincode.showConfirm = !pincode.showConfirm"></v-text-field>
                        </v-col>
                    </v-row>
                </div>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" style="min-width: 100px !important;" @click="changePinCodeDialog = false" :class="{ 'disabled': enableForceFullyChangeSignaturePin && isNeedResetSignaturePin }">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                    <v-btn class="primary" style="min-width: 100px !important;" @click="updatePinCode">{{ $t("res_ButtonText_Save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="addTransferFavoriteDialog" width="55%">
            <v-card>
                <v-card-title>
                    {{ $t("res_DialogTitle_AddTransferFavorite") }}
                </v-card-title>
                <div class="ml-15" style="height: 400px; overflow:scroll;">
                    <v-row class="my-3 ml-3">
                        <v-col class="col-md-8">
                            <span class="mx-3 my-3">
                                {{ $t("res_Label_TransferFavoriteStructure") }} <span style="color: red">*</span>
                            </span>
                            <v-divider></v-divider>
                            <multi-select class="light-bg" label="name" track-by="id" open-direction="bottom"
                                          :options="allStructures" v-model="transferFavorite" :searchable="true"
                                          :internal-search="false" :clear-on-select="false" :close-on-select="true"
                                          :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="false"
                                          :multiple="false" @search-change="asyncFindStructure" @remove="removeTransferFavoriteList"
                                          @close="allStructures = []">
                                <template slot="option" slot-scope="props">
                                    <div style="height: 50px; width: 100%; display: flex">
                                        <div class="" style="">
                                            <v-avatar color="#eff2f5" size="43">
                                                {{ CapitalizeFirstLetter(props.option.name) }}
                                            </v-avatar>
                                        </div>
                                        <div class="ad__box" v-if="props.option.isUser">
                                            <p class="ad__text__bold">{{ props.option.name }}</p>
                                            <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                        </div>
                                        <div class="ad__box" v-else>
                                            <p class="ad__text__bold">{{ props.option.name }}</p>
                                            <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                        </div>
                                    </div>
                                </template>
                                <template slot="noOptions" slot-scope="props">
                                    {{ $t("res_Msgs_EmptySearch") }}
                                </template>
                            </multi-select>
                        </v-col>
                        <v-col class="col-md-4 mt-13">
                            <v-btn fab light small class="white--text" color="#00ae8d" @click="addTransferFavoriteList"
                                   :disabled="this.transferFavorite.length == 1">
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </v-col>
                        <v-divider></v-divider>
                        <draggable :list="this.transferFavoriteList" class="d-flex flex-row">
                            <v-card class="my-5 mx-5" width="25%" elevation="5"
                                    v-for="(item, index) in this.transferFavoriteList" :key="index" style="padding: 10px;">
                                <p style="font-weight: 600; font-size:medium">{{ item.name }}</p>
                            </v-card>
                        </draggable>
                    </v-row>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" style="min-width: 100px !important;"
                           @click="addTransferFavoriteDialog = false">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                    <v-btn class="primary" style="min-width: 100px !important;" @click="addTransferFavorite">
                        {{ $t("res_ButtonText_Save") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="createIncomingDialog" content-class="dialog fullscreen-dialog bg-white" width="100%"
                  fullscreen>
            <div class="dialog-header">
                <v-toolbar class="bg-white">
                    <div class="d-flex align-items-center">
                        <h1 class="mb-0">{{ this.createByFileTitle }}</h1>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="custom-icon-wrapper">
                        <v-icon @click="createIncomingDialog = false">custom-icon mdi-close</v-icon>
                    </div>
                </v-toolbar>
            </div>
            <div class="dialog-body">
                <DWT :categoryId="dwtCategoryId" :dialogModelShow="createIncomingDialog"></DWT>
            </div>
        </v-dialog>

        <v-dialog persistent v-model="createOutgoingDialog" content-class="dialog bg-white choose-template-dialog fullscreen-dialog" fullscreen>
            <div class="dialog-header">
                <v-toolbar class="bg-white">
                    <h1 class="mb-0 chose-template-header">{{ $t("res_MenuItems_ChooseTemplate") }}</h1>
                    <v-spacer></v-spacer>
                    <div class="custom-icon-wrapper">
                        <v-icon @click="createOutgoingDialog=false">custom-icon mdi-close</v-icon>
                    </div>
                </v-toolbar>
            </div>
            <div class="dialog-body">
                <ChooseTemplate @closeSelectTemplatePopup="closeSelectTemplatePopup"
                                :categoryType="createOutgoingDialog_CategroyType" :dialogModelShow="createOutgoingDialog"
                                :refreshToken="refreshToken" :linkedDocumentId="linkedDocumentId"></ChooseTemplate>
            </div>
        </v-dialog>

        <v-dialog v-model="selectRecipientDialog" content-class="dialog2 h-90 with-fixed-actions" width="700">
            <div class="dialog-header">
                <h1>
                    {{ $t("res_MenuItems_Recipient") }}
                </h1>
            </div>
            <div class="dialog-body white-container">
                <address-book></address-book>
            </div>
        </v-dialog>

        <v-dialog v-model="newCorrespondenceDialog" content-class="create-document-dialog fullscreen-dialog corr_dialog" fullscreen persistent>
            <CreateDocumentView :documentId="draftDocumentId" :closeDialogEvent="closeNewCorrespondenceDialog"
                                :openerPage="createDocumentViewOpener" viewMode="edit" :createReplyDocumentEvent="CreateReplyDocument" />
        </v-dialog>

        <v-alert v-if="snackbar_show" text :type="snackbar_type">
            {{ snackbar_text }}
        </v-alert>

        <v-dialog v-model="informationDialog" content-class="small-dialog" width="500" height="350">
            <v-card>
                <v-card-title>
                    <span>{{ information_heading }}</span>
                </v-card-title>
                <div class="card-body">
                    <label>{{ information_text }}</label>
                </div>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn color="light-blue" width="100" @click="informationDialogCancel">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                    <v-btn color="primary" width="100" @click="informationDialogContinue">{{ $t("res_ButtonText_Continue") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--System Notification Dialog-->
        <v-dialog v-model="SystemNotificationDialog" content-class="profile-dialog system-notifiction m-0" width="430px">
            <v-card class="p-2 card-scroll">
                <div class="min-height-58px">
                    <div v-if="systemNotificationList.length == 0">
                        <p class="center-document mt-4"><strong>{{ $t("res_Label_NoData") }}</strong></p>
                    </div>
                    <div v-if="systemNotificationList.length > 0" style="position: relative;"
                         v-for="(transferSystemNotification, index) in systemNotificationList" :key="index"
                         :class="{'border-bottom': index !== systemNotificationList.length - 1 , 'd-flex align-items-center' : 1==1}">
                        <div class="col-1">
                            <span v-if="!transferSystemNotification.isRead" class="blue-dot"></span>
                        </div>
                        <div class="col-11 pb-0" @click="openNotification(transferSystemNotification)"
                             style="font-size: 10px;">
                            <p class="m-0 mb-2 size-14"  >
                               <span v-if="defaultApplicationId==1"> {{ $t("res_Notification_Correspondence") }}&nbsp;</span>
                               <span v-else> {{ $t("res_Notification_commonText") }}&nbsp;</span> 
                                <strong>{{ transferSystemNotification.fullName }}</strong>
                            </p>
                            <p class="m-0 mb-0 p-0 text-truncate size-12">
                                {{ transferSystemNotification.referenceNumber }} - {{ transferSystemNotification.subject }}
                            </p>
                            <p class="m-0 mb-1 p-0 text-truncate text-start size-12" style="color: #c2c2c2; ">
                                {{ utils.formatDateTimeWithTime(transferSystemNotification.createdDate) }}
                            </p>
                        </div>
                        <div v-if="isLanguageEn" style="position: absolute; right: 0; top: 0; padding: 0px; padding-top: 22px; cursor: pointer;"
                             @click="MakeSystemNotificationIsDismissed(transferSystemNotification)">
                            <v-icon>mdi-window-close</v-icon>
                        </div>
                        <div v-else style="position: absolute; left: 0; top: 0; padding: 0px; padding-top: 22px; cursor: pointer;"
                             @click="MakeSystemNotificationIsDismissed(transferSystemNotification)">
                            <v-icon>mdi-window-close</v-icon>
                        </div>
                    </div>
                </div>
            </v-card>
        </v-dialog>

        <!--Correspondence Dialog-->
        <v-dialog v-model="correspondenceDialogOpened" content-class="create-document-dialog fullscreen-dialog corr_dialog" fullscreen v-bind:persistent="true">
            <div id="correspondenceDialogEmptyDiv"></div>
            <CreateDocumentView :documentId="correspondenceDialogObject.documentId"
                                :transferId="correspondenceDialogObject.transferId"
                                :viewMode="correspondenceDialogObject.viewMode"
                                :delegationId="correspondenceDialogObject.delegationId"
                                :toEmail="correspondenceDialogObject.toEmail"
                                :emailCC="correspondenceDialogObject.emailCC"
                                :closeDialogEvent="CloseCorrespondenceDialog"
                                :openedFromNodeId="correspondenceDialogObject.openedFromNodeId"  
                                :createReplyDocumentEvent="CreateReplyDocument"/>
        </v-dialog>

        <v-dialog v-model="manageUserSignaturesDialog" content-class="fullscreen-dialog" fullscreen>
            <div class="dialog-header">
                <v-toolbar class="bg-white">
                    <h1 class="mb-0">
                        {{$t("res_Lable_ManageSignatures")}}
                    </h1>
                    <v-spacer></v-spacer>
                    <div class="custom-icon-wrapper">
                        <v-icon @click="manageUserSignaturesDialog=false">custom-icon mdi-close</v-icon>
                    </div>
                </v-toolbar>
            </div>
            <div class="dialog-body">
                <UserSignatureManager :userid="userId" :dialogModelShow="manageUserSignaturesDialog"
                                      v-on:closeDialog="manageUserSignaturesDialog = false"></UserSignatureManager>
            </div>
        </v-dialog>

        <v-dialog v-model="showAdvancedSearchDialog" content-class="m-0 create-document-dialog fullscreen-dialog corr_dialog">
            <AdvancedSearchFilters class="mt-7 p-4 bg-white rounded-4" @applyFilters="applyFilters">
            </AdvancedSearchFilters>
        </v-dialog>

        <!--loader-->
        <div v-if="display_loader" class="cts_loader">
            <img width="148px" src="/assets/images/icons/loader.svg" />
            <p>{{ $t("res_Msgs_LoadingText") }}</p>
        </div>
    </v-app>
</template>

<script>
    import DWT from './components/DWT'
    import axios from 'axios'
    import constants from './assets/js/constants'
    import MultiSelect from 'vue-multiselect'
    import CreateDocumentView from './views/CreateDocumentView'
    import AddressBook from '@/components/AddressBook.vue'
    import { mapGetters, mapActions } from 'vuex'
    import ChooseTemplate from './components/ChooseTemplate.vue'
    import router from './router/index.js'
    import draggable from "vuedraggable"
    import * as utils from './assets/js/common.js'
    import MessagesUtil from '@/utils/messagesUtil'
    import UserSignatureManager from '@/components/UserSignatureManager.vue'
    import StructureUserSelector from '@/components/StructureUserSelector.vue'
    import Multiselect from 'vue-multiselect'
    import AdvancedSearchFilters from './components/AdvancedSearchFilters.vue'
    import encryptedMethods from '@/utils/encryptedMethods'

    export default {
        name: 'App',
        components: {
            DWT, MultiSelect, CreateDocumentView, AddressBook, ChooseTemplate, draggable, StructureUserSelector, Multiselect, AdvancedSearchFilters, UserSignatureManager
        },
        data: () => ({
            showHelpAppVal: false,
            isShow: false,
            loading: false,
            isAuthenticated: false,
            isLanguageEn: true,
            user: null,
            profileDialog: false,
            userDisplayName: '',
            userId: JSON.parse(sessionStorage.getItem("user")).profile.Id,
            userEmail: '',
            userAbbreviation: '',
            userAbbreviationSrc: '',
            createByFileTitle: '',
            createIncomingDialog: false,
            manageUserSignaturesDialog: false,
            createOutgoingDialog: false,
            createOutgoingDialog_CategroyType: '',
            refreshToken: '',
            fileUploaded: null,
            expandSearch: false,
            defaultSender: {},
            inboxCount: 0,
            draftCount: 0,
            sentCount: 0,
            completedCount: 0,
            ccedCount: 0,
            followUpCount: 0,
            archiveCount: 0,
            linkedDocumentId: 0,

            newCorrespondenceDialog: false,
            selectRecipientDialog: false,
            search_mode: 'All',
            search_modes: ['All', 'Correspondences', 'Notes', 'Attachments', 'Users', 'Templates', 'Reports'],
            draftDocumentId: 0,
            user_structure: {},

            searchQuery: '',
            display_loader: false,
            snackbar_show: false,
            snackbar_text: '',
            snackbar_type: '',

            informationDialog: false,
            information_heading: '',
            information_text: '',
            information_continueHandler: null,
            information_cancelHandler: null,

            changePinCodeDialog: false,

            pincode: {
                setNewPin: "",
                confirmNewPin: "",
                showCurrent: false,
                showNew: false,
                showConfirm: false
            },
            dateTimeOptions: {
                year: "numeric",
                month: '2-digit',
                day: '2-digit',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            dateOptions: {
                year: "numeric",
                month: '2-digit',
                day: '2-digit'
            },
            addTransferFavoriteDialog: false,
            transferFavorite: {},
            transferFavoriteList: [],
            allStructures: [],
            all_user_structures: [],

            isDecreeEnabled: false,
            isCircularEnabled: false,
            createDocumentViewOpener: "",
            constants: constants,
            hasUnOpenedDocuments: false,
            router: router,
            messagesUtil: MessagesUtil,
            showLoadingCount: 0,
            client_logo_name: client_logo_name,
            dwtCategoryId: 1,
            systemNotificationList: [],
            SystemNotificationDialog: false,
            correspondenceDialogOpened: false,
            correspondenceDialogObject: {
                documentId: 0,
                transferId: 0,
                viewMode: 'edit',
                delegationId: 0,
                toEmail: "",
                emailCC: "",
                closeDialogEvent: 0,
                openedFromNodeId: 2,
            },
            utils: utils,
            menuItems: [],
            defaultApplicationId: window.defaultApplicationId,
            showCreateOutgoingByFile: true,
            showAppSwitchButton: window.showAppSwitchButton,
            availableApplications: window.availableApplications,
            showInProfileMenus: window.showInProfileMenus,
            showAdvancedSearchDialog: false,
            selectedItem: null,
            selected: [],
            privacies: [],
            priorities: [],
            from_date_datePicker: false,
            to_date_datePicker: false,
            hideElasticSearch: window.hideElasticSearch,
            hideOpenAdvancedSearchFiltersFromHomePage: window.hideOpenAdvancedSearchFiltersFromHomePage,
            TaskDetailsDialogOpened:false,
            TaskProjecDialogOpened: false,
            taskDialogObject: {
                linkedWithProject: true,
                selectedTaskId: 0,
                projectId: 0,
                isProjectCreator: false,
                isPublic: false
            },
            enableForceFullyChangeSignaturePin: window.enableForceFullyChangeSignaturePin,
            isNeedResetSignaturePin : false,
            tooltipDisplayName: '',
            isMOMEnabled:false
        }),
        async created() {
            this.setRtl();
            this.isDecreeEnabled = constants.isDecreeEnabled
            this.isCircularEnabled = constants.isCircularEnabled
            this.showCreateOutgoingByFile = window.showCreateOutgoingByFile
            this.isMOMEnabled=constants.isMOMEnabled
            window.openNewCreateDocumentView = this.openNewCreateDocumentView;
            window.addEventListener('message', function (event) {
                try {
                    // console.log(event.data);
                    // the below handles coming from ther scanning module
                    if (event.data != undefined && event.data != '' && event.data.lastIndexOf('documentId:') > -1) {
                        var documentId = event.data.replace("documentId:", "");
                        if (isNaN(documentId) == false) {
                            window.openNewCreateDocumentView(parseInt(documentId));
                        }
                    }
                }
                catch (e) { }
            });

            if (sessionStorage.getItem("user") != null) {
                var user = JSON.parse(sessionStorage.getItem("user"))

                this.isAuthenticated = true
                this.user = user.profile
                this.userAbbreviation = this.CapitalizeFirstLetter(this.user.DisplayName)

                this.fetchUserStructures(() => {
                    var user = JSON.parse(sessionStorage.getItem("user"))

                    this.all_user_structures = [...this.allUserStructures]
                    this.all_user_structures.forEach(element => {
                        if (element.structureId == user.profile.StructureId) {
                            this.user_structure = element
                            sessionStorage.setItem('user_structure', JSON.stringify(element))
                        }
                    });
                })

                this.getRoles()

                // this.messagesUtil.dispatchEvent('userLoaded');

                if (window.defaultApplicationId == 1) {
                    await this.fetchTransferPurposes()
                    await this.fetchDocumentCategories()
                }
            }
        },
        beforeMount() {
            window.documentView = {}
            window.showAlert = this.showAlert
            window.showLoading = this.showLoading
            window.hideLoading = this.hideLoading
            window.newDate = this.newDate
            window.dateFormatForExternlUse = utils.dateFormat;
            window.showInformation = this.showInformation
            window.openNewCorrespondenceDialog = this.openNewCorrespondenceDialog
            window.translate = this.translate
            window.dateTimeOptions = this.dateTimeOptions
            window.dateOptions = this.dateOptions
            window.setViewerData = this.setViewerData;
            window.getViewerData = this.getViewerData;
            window.setVisualTrackingData = this.setVisualTrackingData;
            window.setConfigureSignatureData = this.setConfigureSignatureData;
            window.getLocalizedVal = this.getLocalizedVal;
            window.showUaepassAlert=this.showUaepassAlert;

            window.refreshUnOpenedDocument = this.checkForUnOpenedDocuments;
        },
        mounted() { 
            
            var appContext = this;
            this.privacies = constants.privacies;
            this.priorities = constants.priorities;

            this.messagesUtil.listenToEvents(function (eventDetail) {
                if (eventDetail.key == 'createOutgoingOnIncoming') {
                    appContext.refreshToken = new Date().getTime().toString();
                    appContext.createOutgoingDialog_CategroyType = '0';
                    appContext.createOutgoingDialog = true
                    appContext.linkedDocumentId = eventDetail.documentId
                }
            });

            setInterval(function () {
                if (document.getElementsByClassName('bottom-action-bar').length > 0)
                    document.body.classList.add('alert-top')
                else
                    document.body.classList.remove('alert-top')
            }, 1000)

            var user = JSON.parse(sessionStorage.getItem("user"));
            if (user == null)
                document.getElementById("login").click();
            this.tooltipDisplayName = user.profile.DisplayName
            this.asyncFindStructure("");
            this.openDocumentByLink();

            this.search_mode = this.translate('res_CardHeaders_All'),
                this.search_modes = [this.translate('res_CardHeaders_All'), this.translate("res_MenuItems_Correspondences"),
                this.translate("res_MenuItems_Notes"), this.translate("res_Label_Attachments"), this.translate("res_MenuItems_Users"),
                this.translate("res_MenuItems_Templates"), this.translate("res_TabsName_Reports")]
            /*
            if (constants.isDelegationsLoaded == false) {
                axios.get(constants.baseApiUrl + 'Delegation/GetAllActiveDelegationsForUser')
                    .then(res => {
                        constants.delegations = res.data
                        constants.isDelegationsLoaded = true
                    })
                    .catch(err => console.log(err));
            }
            */
            axios.get(constants.baseApiUrl + 'Delegation/GetAllActiveDelegationsForUser')
                    .then(res => {
                        constants.delegations = res.data
                        constants.isDelegationsLoaded = true
                    })
                    .catch(err => console.log(err));
            if (window.defaultApplicationId == 1 || window.defaultApplicationId == 2) {
                setInterval(() => { this.checkForUnOpenedDocuments() }, 5000)
                this.setCounters()
                this.startNotificationsTimer();
            }
            
            if (constants.client_version_Id == 'ADFD') 
            {
                axios.get(constants.baseApiUrl + 'Lookups/GetCustomLookupValues?name=Countries')
                    .then(response => constants.countriesList = response.data)
                    .catch(error => console.log(error))

                axios.get(constants.baseApiUrl + 'Lookups/GetCustomLookupValues?name=Projects')
                    .then(response => constants.projectsList = response.data)
                    .catch(error => console.log(error))

                axios.get(constants.baseApiUrl + 'Lookups/GetCustomLookupValues?name=ProjectNumbers')
                    .then(response => constants.projectsNumbersList = response.data)
                    .catch(error => console.log(error))
            }

            if (constants.client_version_Id == 'NLA') 
            {
                axios.get(constants.baseApiUrl + 'Lookups/GetCustomLookupValues?name=DeliveryTypes')
                    .then(response => constants.deliveryTypesList = response.data)
                    .catch(error => console.log(error))

                axios.get(constants.baseApiUrl + 'Lookups/GetCustomLookupValues?name=MessageTypes')
                    .then(response => constants.messageTypes = response.data)
                    .catch(error => console.log(error))
            }

            if(constants.client_version_Id!="")
            {
                axios.get(constants.baseApiUrl + 'Lookups/GetCustomLookupValues?name=MessageTypes')
                    .then(response => constants.messageTypes = response.data)
                    .catch(error => console.log(error))
            }

            if (constants.disclaimerMessage != null && constants.disclaimerMessage != undefined && constants.disclaimerMessage != '') {
                this.addFloatingDisclaimer(constants.disclaimerMessage)
            }
            var user = JSON.parse(sessionStorage.getItem("user"))
            this.userId = user.profile.Id
            this.isNeedResetSignaturePin = user.profile.IsNeedResetSignaturePin

            if (this.isNeedResetSignaturePin && this.enableForceFullyChangeSignaturePin)
                this.changeSignaturePin();

             this.showHelpAppVal = typeof(window.helpAppUrl) != 'undefined' && window.helpAppUrl != null && window.helpAppUrl != '';

        
        },
        computed: mapGetters(['allUserStructures']),
        beforeDestroy() {
            this.clearNotificationsTimer();
        },
        methods: {
            async openHelpUrl()
            {
                const parseJsonSafe = (value) => {
                    if (!value || typeof value !== "string") return null;
                    try { return JSON.parse(value); } catch { return null; }
                };

                const getStorageItem = (storage, key) => {
                    try {
                        return typeof storage.getItem === "function"
                            ? storage.getItem(key)
                            : storage[key];
                    } catch {
                        return null;
                    }
                };

                const checkAdminRole = (roleText) => {
                    if (!roleText || typeof roleText !== "string") return false;
                    const role = roleText.toLowerCase().replace(/\s+/g, "");
                    return role.includes("admin") ||
                        role.includes("administrator") ||
                        role.includes("fullcontrol")||
                        role.includes("full control");
                };

                if (!window.helpAppUrl) {
                    console.warn("helpAppUrl is not defined on window.");
                    return;
                }

                if (!window.IAMUrl) {
                    console.warn("IAMUrl is not defined on window.");
                    return;
                }


                const HasFullAccess = await this.checkApplicationAccess();
                const userRaw = getStorageItem(sessionStorage, "user") ?? sessionStorage.user;
                const user = parseJsonSafe(userRaw) ?? {};
                const clientsRaw = user?.profile?.Clients;

                let isAdmin = false;
                if (clientsRaw) {
                    if (Array.isArray(clientsRaw)) {
                        for (const clientStr of clientsRaw) {
                            const client = parseJsonSafe(clientStr);
                            if (client?.Role && checkAdminRole(client.Role) && client.ClientId == client_id) {
                                isAdmin = true;
                                break;
                            }
                        }
                    } else if (typeof clientsRaw === "string") {
                        const client = parseJsonSafe(clientsRaw);
                        if (client?.Role) {
                            isAdmin = checkAdminRole(client.Role);
                        }
                    }
                }

                const type = isAdmin ? "A" : "U";
                const lang = getStorageItem(localStorage, "lang") ?? localStorage.lang ?? "en";
                const url = new URL(window.helpAppUrl, window.location.origin);

                url.searchParams.set("lang", lang);
                url.searchParams.set("system", "C");
                url.searchParams.set("type", type);
                url.searchParams.set("fullAccess", HasFullAccess);
                const ts = Date.now();
                const rand = crypto.getRandomValues(new Uint8Array(12));
                const nonce = Array.from(rand, b => b.toString(16).padStart(2,'0')).join('');
                const token = `${ts}:${nonce}`;
                // 2) open a real popup (NO features string)
                const w = window.open('', '_blank');   // <-- no "noopener" or "noreferrer"
                if (!w) { alert('Popup blocked'); return; }
                // 3) sever the opener manually (noopener effect) while still same-origin
                try { w.opener = null; } catch {}
                // 4) stash token and navigate FROM THE OPENER
                w.name = token;
                w.location.replace(url.toString());
            },
         async openHelpUrlOld() {  
                const parseJsonSafe = (value) => {
                    if (!value || typeof value !== "string") return null;
                    try { return JSON.parse(value); } catch { return null; }
                };


                const getStorageItem = (storage, key) => {
                    try {
                        return typeof storage.getItem === "function"
                            ? storage.getItem(key)
                            : storage[key];
                    } catch {
                        return null;
                    }
                };
 
                const checkAdminRole = (roleText) => {
                    if (!roleText || typeof roleText !== "string") return false;
                    const role = roleText.toLowerCase().replace(/\s+/g, "");
                    return role.includes("admin") ||
                        role.includes("administrator") ||
                        role.includes("fullcontrol")||
                        role.includes("full control");
                };


                if (!window.helpAppUrl) {
                    console.warn("helpAppUrl is not defined on window.");
                    return;
                }


                if (!window.IAMUrl) {
                    console.warn("IAMUrl is not defined on window.");
                    return;
                }


               
                const HasFullAccess = await this.checkApplicationAccess();
                const userRaw = getStorageItem(sessionStorage, "user") ?? sessionStorage.user;
                const user = parseJsonSafe(userRaw) ?? {};
                const clientsRaw = user?.profile?.Clients;


                let isAdmin = false;
                if (clientsRaw) {
                    if (Array.isArray(clientsRaw)) {
                        for (const clientStr of clientsRaw) {
                            const client = parseJsonSafe(clientStr);
                            debugger;
                            if (client?.Role && checkAdminRole(client.Role) && client.ClientId == client_id) {
                                isAdmin = true;
                                break;
                            }
                        }
                    } else if (typeof clientsRaw === "string") {
                        const client = parseJsonSafe(clientsRaw);
                        if (client?.Role) {
                            isAdmin = checkAdminRole(client.Role);
                        }
                    }
                }


                const type = isAdmin ? "A" : "U";
                const lang = getStorageItem(localStorage, "lang") ?? localStorage.lang ?? "en";
                const url = new URL(window.helpAppUrl, window.location.origin);
               
                url.searchParams.set("lang", lang);
                url.searchParams.set("system", "C");
                url.searchParams.set("type", type);
                url.searchParams.set("fullAccess", HasFullAccess);
               
               
                window.open(url.toString(), "_blank", "noopener,noreferrer");
            },
            async checkApplicationAccess() {
                try {
                    const user = JSON.parse(sessionStorage.user);
                    const userId = user.profile.sub;
                    const token = sessionStorage.getItem('jwt_token');

                    const response = await axios.get(`${window.IAMUrl}Api/HasApplicationAccess?id=${userId}&name=DMS`, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });

                    if (response.status === 200 && response.data) {
                        return response.data;
                    } else {
                        return false;
                    }
                } catch (error) {
                    // Handle any errors (401, network issues, etc.)
                    console.error('Error checking application access:', error);
                    return false;
                }
            },
            async checkApplicationAccessOld() {  
                try {
                    const user = JSON.parse(sessionStorage.user);
                    const userId = user.profile.sub;
                    const token = sessionStorage.getItem('jwt_token');
                   
                    const response = await axios.get(`${window.IAMUrl}Api/HasApplicationAccess?id=${userId}&name=DMS`, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });  
                     
                    if (response.status === 200 && response.data) {
                        return response.data;
                    } else {
                        return false;
                    }
                } catch (error) {
                    // Handle any errors (401, network issues, etc.)
                    console.error('Error checking application access:', error);
                    return false;
                }
            },
 


            CreateReplyDocument(){
                this.refreshToken = new Date().getTime().toString()
                this.createOutgoingDialog_CategroyType = categoryType
                this.createOutgoingDialog = true
            },
            closeTaskDetailsDialog() {
            this.taskDialogObject = {};
			this.TaskDetailsDialogOpened = false;
			this.TaskProjecDialogOpened = false;
		    },
            closeTaskProjectDialog(){
            this.taskDialogObject = {};
			this.TaskDetailsDialogOpened = false;
			this.TaskProjecDialogOpened = false;
            },
            setStructure(item, type) {
                if (type == 1)
                    this.filter.fromStructure = item;
                else
                    this.filter.toStructure = item
            },
            setUser(selectedUserItem, type) {
                if (type == 1) {
                    this.filter.fromUser = selectedUserItem;
                    this.filter.fromUser.id = selectedUserItem.id.split('-')[0];
                }
                else {
                    this.filter.toUser = selectedUserItem;
                    this.filter.toUser.id = selectedUserItem.id.split('-')[0];
                }
            },
            ...mapActions(['fetchUserStructures', 'fetchTransferPurposes', 'fetchDocumentCategories']),
            openAddSignatureDialog() {
                console.log('true');
                this.isSignatureModelShow = true;
            },
            openProfileBox() {
                var user = JSON.parse(sessionStorage.getItem("user"))
                this.userDisplayName = user.profile.DisplayName
                this.userId = user.profile.Id
                this.userEmail = user.profile.Email
                this.profileDialog = !this.profileDialog
            },
            hasPermission(name) 
            {
                if (constants.userActions && constants.userActions.features) {
                    return constants.userActions.features.some(f => f.name.toLowerCase() == name.toLowerCase());
                }

                return false;
            },
            userStructureChanged() {
                axios.post(constants.baseApiUrl + 'StructureUser/ChangeUserDefaultStructure?structureId=' + this.user_structure.structureId, null)
                    .then(response => {
                        sessionStorage.setItem('user', null)
                        sessionStorage.setItem('jwt_token', null)
                        window.location.href = window.location.origin + '/login2.html'
                    })
                    .catch(error => console.log(error));
            },
            async changeRTL(direction) {
                this.showLoading();
                this.isLanguageEn = direction ? false : true;
                this.$i18n.locale = direction ? 'ar' : 'en'
                this.$vuetify.rtl = direction
                // sessionStorage.setItem('lang', direction ? 'ar' : 'en')
                localStorage.setItem('lang', direction ? 'ar' : 'en')
                window.location.reload()
            },
            setRtl() {
                var isDirectionRtl = localStorage.getItem('lang') == 'ar' ? true : false;
                this.isLanguageEn = isDirectionRtl ? false : true;
                this.$i18n.locale = isDirectionRtl ? 'ar' : 'en'
                this.$vuetify.rtl = isDirectionRtl
            },
            logout() {
                document.getElementById("logout").click();
            },
            openCreateIncomingPopup() {
                this.dwtCategoryId = 1
                this.createByFileTitle = this.translate("res_MenuItems_CreateIncoming")
                this.createIncomingDialog = true
            },
            openCreateOutgoingAttachPopup() {
                this.dwtCategoryId = 2
                this.createByFileTitle = this.translate("res_MenuItems_CreateOutgoing")
                this.createIncomingDialog = true
            },
            DownloadFile(url) {
                //Create XMLHTTP Request.
                var req = new XMLHttpRequest();
                req.open("GET", url, true);
                req.setRequestHeader("Authorization", 'Bearer ' + sessionStorage.getItem('jwt_token'));
                req.responseType = "blob";
                req.onload = function () {
                    //Convert the Byte Data to BLOB object.
                    var blob = new Blob([req.response], { type: "application/octetstream" });

                    //Check the Browser type and download the File.
                    var isIE = false || !!document.documentMode;
                    if (isIE) {
                        window.navigator.msSaveBlob(blob, "PrintedFile.pdf");
                    }
                    else {
                        var url = window.URL || window.webkitURL;
                        var link = url.createObjectURL(blob);
                        var a = document.createElement("a");
                        a.setAttribute("download", "PrintedFile.pdf");
                        a.setAttribute("href", link);
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }
                };
                req.send();
            },
            openCreateOutgoingPopup(categoryType) {
                this.refreshToken = new Date().getTime().toString()
                this.createOutgoingDialog_CategroyType = categoryType
                this.createOutgoingDialog = true
            },
            uploadFile() {
                this.fileUploaded = this.$refs.file.files[0];
            },
            closeNewCorrespondenceDialog(openerPage) {
                this.draftDocumentId = 0
                this.linkedDocumentId = 0
                this.newCorrespondenceDialog = false
                if (window.refreshInbxGrid != undefined && window.refreshInbxGrid != null)
                    window.refreshInbxGrid()

                switch (openerPage) {
                    case "chooseTemplate":
                        this.createOutgoingDialog = true
                        break;
                    case "createIncomingDialog":
                        this.createIncomingDialog = true
                        break;
                    default:
                        console.log(openerPage);
                }
            },
            closeSelectTemplatePopup(documentId) {
                this.createOutgoingDialog_CategroyType = ''
                this.createOutgoingDialog = false
                if (documentId != 0) {
                    this.openNewCorrespondenceDialog(documentId)
                }
                else {
                    this.draftDocumentId = 0
                    this.linkedDocumentId = 0
                }
            },
            openNewCorrespondenceDialog(documentId) {
                axios.get(constants.baseApiUrl + 'User/GetCurrentUser')
                    .then(res => {
                        if (res.data != null && res.data != undefined) {
                            this.defaultSender = {}
                            this.defaultSender.id = res.data[0].structureId;
                            this.defaultSender.name = res.data[0].structureName;
                            this.defaultSender.isUser = false;
                        }
                        this.draftDocumentId = documentId
                        this.createDocumentViewOpener = "chooseTemplate";
                        this.newCorrespondenceDialog = true;
                    }
                    ).catch(err => console.warn(err))

            },
            openNewCreateDocumentView(documentId) {
                this.defaultSender = {}
                this.draftDocumentId = documentId
                this.createDocumentViewOpener = "createIncomingDialog";
                this.newCorrespondenceDialog = true
                this.createIncomingDialog = false
            },
            showAlert(text, type) {
                var textValue = this.translate(text)
                this.snackbar_text = this.translate(textValue);
                this.snackbar_type = type;
                this.snackbar_show = true;
                setTimeout(() => {
                    this.snackbar_show = false;
                }, 3000);
            },
               showUaepassAlert(text, type) {
                var textValue = this.translate(text)
                this.snackbar_text = this.translate(textValue);
                this.snackbar_type = type;
                this.snackbar_show = true;
                setTimeout(() => {
                    this.snackbar_show = false;
                }, 10000);
            },
            showInformation(heading, text, continueHandler, cancelHandler) {
                this.information_heading = this.translate(heading)
                this.information_text = this.translate(text)
                this.information_continueHandler = continueHandler
                this.information_cancelHandler = cancelHandler
                this.informationDialog = true
            },
            informationDialogCancel() {
                this.informationDialog = false
                if (this.information_cancelHandler != null)
                    this.information_cancelHandler()
            },
            informationDialogContinue() {
                this.informationDialog = false
                if (this.information_continueHandler != null)
                    this.information_continueHandler()
            },
            showLoading() {
                this.display_loader = true
                this.showLoadingCount++;
            },
            hideLoading() {
                this.showLoadingCount--;
                if (this.showLoadingCount < 1) {
                    this.showLoadingCount = 0;
                    this.display_loader = false
                }
            },
            newDate() {
                return new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000);
            },
            clearSearchResult() {
                this.expandSearch = false;
                this.searchQuery = '';
            },
            searchButtonClicked() {
                var r = new Date().getTime().toString()
                if (this.searchQuery.trim().length < 3) {
                    window.showAlert(this.translate("res_Msg_MinThreeCharsToSearch"), 'error');
                    return false;
                }
                if (this.searchQuery != null && this.searchQuery != undefined && this.searchQuery != '') {
                    if (this.search_mode == this.translate('res_CardHeaders_All'))
                        router.push({ path: 'search', query: { q: this.searchQuery, t: '1', r: r } })

                    else if (this.search_mode == this.translate("res_MenuItems_Correspondences"))
                        router.push({ path: 'search', query: { q: this.searchQuery, t: '2', r: r } })

                    else if (this.search_mode == this.translate("res_MenuItems_Notes"))
                        router.push({ path: 'search', query: { q: this.searchQuery, t: '3', r: r } })

                    else if (this.search_mode == this.translate("res_Label_Attachments"))
                        router.push({ path: 'search', query: { q: this.searchQuery, t: '4', r: r } })

                    else if (this.search_mode == this.translate("res_MenuItems_Users"))
                        router.push({ path: 'search', query: { q: this.searchQuery, t: '5', r: r } })

                    else if (this.search_mode == this.translate("res_MenuItems_Templates"))
                        router.push({ path: 'search', query: { q: this.searchQuery, t: '6', r: r } })

                    else if (this.search_mode == this.translate("res_TabsName_Reports"))
                        router.push({ path: 'search', query: { q: this.searchQuery, t: '7', r: r } })
                }
                else {
                    window.showAlert("res_Msgs_ProvideQuery", 'warning');
                }
            },
            getRoles() 
            {
                axios.get(constants.baseApiUrl + 'Document/get-all-roles')
                    .then(res => 
                    {
                        constants.isApplicaitonRolesLoaded = true
                        if (res.data != null && res.data != undefined)
                            constants.applicationRoles = res.data
                    })
            },
            clearPinCodeFileds() 
            {
                this.pincode.setNewPin = "";
                this.pincode.confirmNewPin = "";
            },
            addTransferFavoriteList() {
                let count = 0;
                var strElementId = this.transferFavorite.id.toString()

                if (this.transferFavoriteList.length > 0) {
                    this.transferFavoriteList.filter(fav => {

                        if (strElementId.includes('-')) {
                            if (fav.userId === strElementId.split('-')[0] && fav.structureId === strElementId.split('-')[1] && fav.name === item.name) { }
                            else
                                count++;
                        }
                        else {
                            if (fav.userId === "" && fav.structureId === strElementId && fav.name === this.transferFavorite.name) { }
                            else
                                count++;

                        }
                    });
                }

                if (this.transferFavoriteList.length <= 0 || count == this.transferFavoriteList.length) {
                    if (strElementId.includes('-')) {
                        var body = {
                            userId: strElementId.split('-')[0],
                            structureId: strElementId.split('-')[1],
                            name: this.transferFavorite.name
                        }

                        this.transferFavoriteList.push(body)
                    }
                    else {
                        var body = {
                            userId: "",
                            structureId: this.transferFavorite.id,
                            name: this.transferFavorite.name
                        }

                        this.transferFavoriteList.push(body)
                    }
                }

                this.transferFavorite = {}
            },
            removeTransferFavoriteList(item) {
                var strElementId = item.id.toString();

                var arrayWithoutCurrentItem = this.transferFavoriteList.filter(fav => {

                    if (strElementId.includes('-')) {
                        if (fav.userId === strElementId.split('-')[0] && fav.structureId === strElementId.split('-')[1] && fav.name === item.name)
                            return false;
                        else
                            return true;
                    }
                    else {
                        return (fav.structureId !== item.id && fav.name !== item.name)
                    }
                });

                this.transferFavoriteList = arrayWithoutCurrentItem
            },
            openAddTransferFavorite() {
                this.profileDialog = false
                this.transferFavoriteList = [];

                axios.get(constants.baseApiUrl + 'Transfer/GetTransferFavorite?UserId=' + this.userId
                    + '&StructureId=' + this.user_structure.structureId, { headers: constants.headers })
                    .then(response => {
                        if (response.data != null && response.data) {
                            response.data.forEach(fav => {
                                var favLstBody = {
                                    userId: fav.favUserId,
                                    structureId: fav.favStructureId,
                                    name: fav.name
                                }

                                this.transferFavoriteList.push(favLstBody)
                            })
                        }
                    })
                    .catch(err => console.warn(err))

                this.addTransferFavoriteDialog = true;
            },
            openChangePinCode()
            {
                this.profileDialog = false
                this.changePinCodeDialog = true
            },
            addTransferFavorite() {
                if (this.transferFavoriteList.length > 1) {
                    var body = {
                        userId: this.userId,
                        structureId: this.user_structure.structureId,
                        FavUserIds: this.transferFavoriteList.map(a => a.userId),
                        FavStructureIds: this.transferFavoriteList.map(a => a.structureId)
                    }
                    axios.post(constants.baseApiUrl + 'Transfer/UpdateTransferFavorite', body, { headers: constants.headers })
                        .then(response => {
                            if (response.data != null && response.data) {
                                window.showAlert(this.translate("res_Msgs_NewTransferFavoriteStructureAddition"), 'success');
                                this.transferFavorite = [{ id: '0', name: '' }];
                                this.addTransferFavoriteDialog = false;
                            }
                        })
                        .catch(err => console.warn(err))
                }
            },
            updatePinCode() 
            {
                if (this.pincode.setNewPin != "" && this.pincode.confirmNewPin != "") 
                {
                    if (this.pincode.setNewPin == this.pincode.confirmNewPin) 
                    {
                        var body = {NewSignaturePin: this.pincode.confirmNewPin }

                        axios.post(constants.baseApiUrl + 'User/UpdateUserSignaturePin', body, { headers: constants.headers })
                            .then(response => 
                            {
                                if (response.data != null && response.data > 0) 
                                {
                                    window.showAlert(this.translate("res_Msgs_SignaturePinCodeUpdation"), 'success');
                                    this.clearPinCodeFileds();
                                    this.changePinCodeDialog = false;
                                    this.isNeedResetSignaturePin = false;
                                }
                                else if (response.data != null && response.data == 0) 
                                {
                                    window.showAlert(this.translate("res_Msgs_WrongPinCode"), 'warning');
                                }
                                else if (response.data != null && response.data == -1) 
                                {
                                    window.showAlert(this.translate("res_Msgs_AddPinCodeFirst"), 'warning');
                                    this.clearPinCodeFileds();
                                    this.changePinCodeDialog = false;
                                }
                            })
                            .catch(err => console.warn(err))
                    }
                    else
                        window.showAlert(this.translate("res_Msgs_PinCodeNotMatching"), 'warning')
                }
                else
                    window.showAlert(this.translate("res_Msgs_FillRequired"), 'warning')
            },
            asyncFindStructure(query) {
                if (query == '') return;

                this.allStructures = [];
                var methodUrl = 'StructureUser/search?showUsers=true&showInternalStructures=true&showExternalStructures=true&search=';

                axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers })
                    .then(res => {
                        this.allStructures = res.data;
                    })
                    .catch(err => console.warn(err))
            },
            translate(text) {
                if (this.$i18n.locale == 'en')
                    return this.$i18n._getMessages().en[text] == null ? text : this.$i18n._getMessages().en[text]
                else
                    return this.$i18n._getMessages().ar[text] == null ? text : this.$i18n._getMessages().ar[text]
            },
            CapitalizeFirstLetter(str) {
                return utils.CapitalizeFirstLetter(str)
            },
            GetMultiSelectSubHeaderDisplay(options) {
                return utils.GetMultiSelectSubHeaderDisplay(options)
            },
            checkForUnOpenedDocuments() {
                axios.get(constants.baseApiUrl + 'Document/CheckUserHasUnOpenedDocument')
                    .then(res => {
                        this.inboxCount = res.data
                        this.hasUnOpenedDocuments = (res.data > 0 ? true : false)
                    })
                    .catch(err => console.log(err));
            },
            getBoxCount(nodeId) {
                if (nodeId == 2) {
                    axios.get(constants.baseApiUrl + 'Document/CheckUserHasUnOpenedDocument')
                        .then(res => {
                            this.inboxCount = res.data
                            this.hasUnOpenedDocuments = (res.data > 0 ? true : false)
                        })
                        .catch(err => console.log(err));
                }
                else {
                    var formData = new FormData();
                    formData.append('nodeId', nodeId)
                    formData.append('delegationId', 0)
                    formData.append('pageIndex', 0)
                    formData.append('pageSize', 20)
                    formData.append('getCountOnly', true)

                    axios.post(constants.baseApiUrl + 'Transfer/List', formData)
                        .then((res) => {
                            if (nodeId == 1)
                                this.draftCount = res.data
                            else if (nodeId == 6)
                                this.sentCount = res.data
                            else if (nodeId == 8)
                                this.archiveCount = res.data
                            else if (nodeId == 9)
                                this.followUpCount = res.data
                            else if (nodeId == 10)
                                this.ccedCount = res.data
                            else if (nodeId == 13)
                                this.completedCount = res.data
                        })
                        .catch(err => console.log(err));
                }
            },
            setViewerData(id, documentId, versionId,fileName) {
                this.viewerData = [{ key: 'id', value: id }, { key: 'documentid', value: documentId }];
                if (versionId) {
                    this.viewerData.push({ key: 'versionid', value: versionId });
                }
                if (fileName) {
                    this.viewerData.push({ key: 'filename', value: fileName });
                }
            },
            getViewerData(key) {
                if (this.viewerData) {
                    if (key)
                        key = key.toLowerCase()

                    let item = this.viewerData.filter(x => x.key == key)[0];
                    if (item)
                        return item.value
                }
                return null
            },
            setVisualTrackingData(documentId) {
                sessionStorage.setItem("s_swq", documentId);
            },
            setConfigureSignatureData(documentId, attachmentId) {
                sessionStorage.setItem("config_swq_id1", documentId);
                sessionStorage.setItem("config_swq_id2", attachmentId);
            },
            getLocalizedVal(enVal, arVal) {
                if (this.$i18n.locale == 'ar' && arVal) {
                    return arVal;
                }

                return enVal;
            },
            setCounters() {
                if (enableCountOnInbox) this.getBoxCount(2);
                if (enableCountOnCced) this.getBoxCount(10);
                if (enableCountOnDraft) this.getBoxCount(1);
                if (enableCountOnSent) this.getBoxCount(6);
                if (enableCountOnFollowUp) this.getBoxCount(9);
                if (enableCountOnArchive) this.getBoxCount(8);
                if (enableCountOnCompleted) this.getBoxCount(13)

                setTimeout(() => { this.setCounters() }, 3000)
            },
            GetAllSystemNotifications() {
                axios.get(constants.baseApiUrl + 'SystemNotification/GetAllSystemNotifications?applicationId='+this.defaultApplicationId)
                    .then(response => {
                        if (response.data != null && response.data != undefined)
                            this.systemNotificationList = response.data
                    })
                    .catch(error => console.log(error));
            },
            OpenSystemNotificationsDialog() {
                this.GetAllSystemNotifications();
                this.SystemNotificationDialog = !this.SystemNotificationDialog
            },
            MakeSystemNotificationIsDismissed(item) {
                window.showLoading()
                axios.get(constants.baseApiUrl + 'SystemNotification/SystemNotificationIsDismissed?SystemNotificationId=' + item.id+'&applicationId='+this.defaultApplicationId)
                    .then(response => {
                        window.hideLoading();
                    })
                    .catch(error => console.log(error));

                this.systemNotificationList.splice(this.systemNotificationList.findIndex(i => i.id === item.id), 1)
            },

            openNotification(item){
                window.showLoading();
                axios.get(constants.baseApiUrl + 'SystemNotification/SystemNotificationIsRead?SystemNotificationId=' + item.id+'&applicationId='+this.defaultApplicationId)
                    .then(response => {
                        window.hideLoading()
                        let index = this.systemNotificationList.findIndex(i => i.id == item.id);
                        this.systemNotificationList[index].isRead = true;
                    })
                    .catch(error => console.log(error));
                if(this.defaultApplicationId==2)
                 this.OpenTaskNotification(item)
                else 
                this.OpenSystemNotification(item)
            },
            OpenSystemNotification(item) {
                this.correspondenceDialogObject.transferId = item.transferId;
                this.correspondenceDialogObject.documentId = item.documentId;
                this.correspondenceDialogOpened = true;
                this.SystemNotificationDialog = false;
            },
            OpenTaskNotification(item) {
            if(item.projectId!=null && item.projectId!=undefined&& item.projectId>0){
				this.taskDialogObject.projectId=item.projectId;
				this.taskDialogObject.linkedWithProject=true;
                this.taskDialogObject.isProjectCreator=false
                this.taskDialogObject.isPublic=false;
			}else{
				this.taskDialogObject.projectId=0;
                this.taskDialogObject.linkedWithProject=false;
                this.taskDialogObject.isProjectCreator=false;
                this.taskDialogObject.isPublic=false;
			}

            if(item.taskId!=null && item.taskId!=undefined&& item.taskId>0){
                this.taskDialogObject.selectedTaskId=item.taskId;
                this.TaskDetailsDialogOpened=true;
			}else{
                this.TaskProjecDialogOpened=true;
			    }
                this.SystemNotificationDialog = false;
            },
            CloseCorrespondenceDialog() {
                this.correspondenceDialogObject.transferId = this.correspondenceDialogObject.documentId = this.correspondenceDialogObject.delegationId = 0;
                this.correspondenceDialogOpened = false;
            },
            startNotificationsTimer() {
                this.GetAllSystemNotifications();
                setInterval(() => { this.GetAllSystemNotifications() }, constants.refreshSystemNotificationTimer);
            },
            clearNotificationsTimer() {
                clearInterval(this.notificationTimer);
            },
            addFloatingDisclaimer(msg) {
                const disclaimerDiv = document.createElement('div')
                disclaimerDiv.classList.add('floating-disclaimer')
                disclaimerDiv.innerHTML = msg
                disclaimerDiv.style.position = 'fixed'
                disclaimerDiv.style.top = '0'
                disclaimerDiv.style.left = '25%'
                disclaimerDiv.style.width = '50%'
                disclaimerDiv.style.background = 'rgba(255, 255, 255, 0.8)'
                disclaimerDiv.style.padding = '10px'
                disclaimerDiv.style.textAlign = 'center'
                disclaimerDiv.style.zIndex = '9999'
                disclaimerDiv.style.color = 'red'
                disclaimerDiv.style.fontSize = '16px'
                document.body.appendChild(disclaimerDiv)
            },
            setDefaultApplication(applicationId) {
                var userSettingsJSON = JSON.stringify({
                    defaultApplicationId: applicationId,
                    defaultPageUrl: "yourDefaultPageUrl"
                });

                document.cookie = "usersettings=" + encodeURIComponent(userSettingsJSON) + "; expires=Thu, 01 Jan 2099 00:00:00 UTC; path=/";

                if (applicationId == 1)
                    window.location.href = window.location.origin + "/inbox";
                else if (applicationId == 2)
                    window.location.href = window.location.origin + "/task";
                else if (applicationId == 3)
                    window.location.href = window.location.origin + "/meeting-mycalendar";
            },
            applyFilters(updatedFilters, isSimpleSearch) 
            {
                if (isSimpleSearch)
                {
                    updatedFilters.subject = this.searchQuery;
                    updatedFilters.enableAdvancedSearch = false;    
                }
                
                this.navigateAndSearch(updatedFilters);
            },
            navigateAndSearch(updatedFilters) 
            {
                this.showAdvancedSearchDialog = false;
                sessionStorage.setItem('advanced_search_filters', JSON.stringify(updatedFilters));
                
                router.push({ path: 'AdvancedSearch', query: { fromSession: true, r: new Date().getTime().toString() } })
            },
            changeSignaturePin(){
                this.openChangePinCode();
            }, 
            async openDocumentByLink(){
                var transferId = sessionStorage.getItem('encTransferId');
                sessionStorage.removeItem('encTransferId');
                var documentId = sessionStorage.getItem('encDocId');
                sessionStorage.removeItem('encDocId');

                this.correspondenceDialogObject.transferId = 0;
                this.correspondenceDialogObject.documentId = 0;
                this.correspondenceDialogObject.openedFromNodeId = 2;
                this.correspondenceDialogObject.viewMode = 'readonly';

                if(transferId){ 

                        this.transferId = parseInt(encryptedMethods.decryptParam(transferId));
                        this.correspondenceDialogObject.transferId = this.transferId;

                        if(documentId){
                            this.documentId = parseInt(encryptedMethods.decryptParam(documentId));
                            this.correspondenceDialogObject.documentId = this.documentId;
                        }

                        await axios.get(constants.baseApiUrl + 'Transfer/GetTransferForNotificationProccessing?documentId='+ this.documentId +'&transferId=' + this.transferId)
                        .then((res) => {
                            var transfer = res.data;
                            if(transfer.id && !transfer.cced){
                                this.correspondenceDialogOpened = true;
                            }
                            else if (transfer.id && transfer.cced){

                                this.correspondenceDialogObject.openedFromNodeId = 10; 
                                this.correspondenceDialogOpened = true;
                            }
                            else{

                                this.correspondenceDialogObject.openedFromNodeId = 2; 
                                this.correspondenceDialogOpened = true;
                            }

                        }).catch(err => console.log(err));

                    return;
                }   
                if(documentId){
                    
                    this.documentId = parseInt(encryptedMethods.decryptParam(documentId));
                    this.correspondenceDialogObject.documentId =  this.documentId; 
                    this.correspondenceDialogObject.openedFromNodeId = 2;             
                    this.correspondenceDialogOpened = true;
                    return;
                }  
            }, 
        },
    }
</script>

<style scoped>
    .blue-dot {
        width: 8px;
        height: 8px;
        background-color: #205cdf;
        border-radius: 50%;
        display: inline-block;
        margin-right: 5px;
    }

    .red-dot {
        width: 8px;
        height: 8px;
        background-color: red;
        border-radius: 50%;
        position: absolute;
        bottom: 18px;
        right: 5px;
    }

    .card-scroll {
        max-height: 400px;
        overflow-y: auto;
    }

    .profile-icons {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: space-around;
        text-decoration: none;
    }

    .profile-icons-container:hover {
        background-color: #eff2f5;
    }

    .expand-advance-search {
        padding: 0px 8px;
        margin: 0px 0px;
        border-radius: 4px;
        background-color: #698bb8;
    }

    .profileIconsCustom { text-align: center; }
    .profileIconsCustom .v-icon::before { font-size: 27px; }
</style>